module.exports = __webpack_public_path__ + "img/preventionInfCVP.257d2192.jpg";